import { render, staticRenderFns } from "./CallcenterForm.vue?vue&type=template&id=a032ee48"
import script from "./CallcenterForm.vue?vue&type=script&lang=js"
export * from "./CallcenterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports